import createReactClass from 'create-react-class'

import { SchemaBranchMixin } from 'legacy/libs/baobab-react-mixins'
import { ValidationBox, Input } from 'legacy/libs/react-form-tools'

import { GetText } from 'lib/gettext'

export default createReactClass({
  displayName: 'Name',

  mixins: [SchemaBranchMixin],

  schema: {
    name: null,
  },

  render() {
    return (
      <ValidationBox
        fieldPath="name"
        className="validationbox"
        errorMessageClassName="text-danger text-xs mt-1"
      >
        <label htmlFor="name" className="mb-2 block text-default-light">
          <GetText>Name</GetText>
        </label>

        <Input id="name" className="input" maxLength="140" />
      </ValidationBox>
    )
  },
})
